import React, {  useState } from "react";
import "./footer.scss";
import { PageRoutes } from "../../utils/pageRoutes";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigation = useNavigate();
  const [footerTICCAExp, setFooterTICCAExp] = useState(false);

  return (
    <>
      <div className="footer-main-dev">
        <div className="footer-dev-flex">
          <img
            className="footer-img"
            src="https://public.ticca.com/images/logo/Logo_T_White.svg"
          />
          <div>
            <p className="footer-list-title">
              TICCA{" "}
              <samp
                onClick={() => {
                  setFooterTICCAExp(!footerTICCAExp);
                }}
              >
                {" "}
                <img
                  className={`${footerTICCAExp ? "samp-rotade" : ""}`}
                  src="https://public.ticca.com/images/svg/FooterArrow.svg"
                  alt="arrow down"
                />
              </samp>
            </p>
            <ul className={footerTICCAExp ? "active" : ""}>
              <li>Desktop app</li>
              <li>Mobile app</li>
              <li>Web app</li>
              <li>Features</li>
              <li>Security</li>
            </ul>
          </div>
          <div>
            <p className="footer-list-title">
              Products{" "}
              <samp
                onClick={() => {
                  setFooterTICCAExp(!footerTICCAExp);
                }}
              >
                {" "}
                <img
                  className={`${footerTICCAExp ? "samp-rotade" : ""}`}
                  src="https://public.ticca.com/images/svg/FooterArrow.svg"
                  alt="arrow down"
                />
              </samp>
            </p>
            <ul className={footerTICCAExp ? "active" : ""}>
              <li
                onClick={() => {
                  return;
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/features/project",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/features/project",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/features/project",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/features/project",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                Project Management
              </li>
              <li
                onClick={() => {
                  return;
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/features/team",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/features/team",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/features/team",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/features/team",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                Team
              </li>
              <li
                onClick={() => {
                  return;
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );

                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                POW
              </li>
              <li
                onClick={() => {
                  return;
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/features/ProofOfWork",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                TimeTrack
              </li>
              <li
                onClick={() => {
                  return;
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/features/meeting",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/features/meeting",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/features/meeting",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/features/meeting",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                Meeting
              </li>
              <li
                onClick={() => {
                  return;
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/features/calendar",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/features/calendar",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/features/calendar",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/features/calendar",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                Calendar
              </li>
              <li
                onClick={() => {
                  return;
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/features/payroll",
                        "_blank",
                        "noopener,noreferrer"
                      );

                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/features/payroll",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/features/payroll",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/features/payroll",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                Payroll
              </li>
              <li>Kanban</li>
              <li>Analytics</li>
              <li>Scheduling</li>
              <li>Map</li>
              <li>GANT</li>
              <li>GPS/Geolocation</li>
            </ul>
          </div>
          <div>
            <p className="footer-list-title">
              Support{" "}
              <samp onClick={() => setFooterTICCAExp(!footerTICCAExp)}>
                {" "}
                <img
                  className={`${footerTICCAExp ? "samp-rotade" : ""}`}
                  src="https://public.ticca.com/images/svg/FooterArrow.svg"
                  alt="arrow down"
                />
              </samp>
            </p>
            <ul className={footerTICCAExp ? "active" : ""}>
              <li
                onClick={() => {
                  navigation(PageRoutes.PrivacyPolicy);
                }}
              >
                Privacy Policy
              </li>

              <li
                onClick={() => {
                  navigation(PageRoutes.TeamsOfUse);
                }}
              >
                Terms of Use
              </li>
              <li
                onClick={() => {
                  navigation(PageRoutes.CookiePolicy);
                }}
              >
                Cookie Policy
              </li>
            </ul>
          </div>
          <div>
            <p className="footer-list-title">
              Security{" "}
              <samp onClick={() => setFooterTICCAExp(!footerTICCAExp)}>
                {" "}
                <img
                  className={`${footerTICCAExp ? "samp-rotade" : ""}`}
                  src="https://public.ticca.com/images/svg/FooterArrow.svg"
                  alt="arrow down"
                />
              </samp>
            </p>
            <ul className={footerTICCAExp ? "active" : ""}>
              <li
                onClick={() => {
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      window.open(
                        "https://dev.www.ticca.com/data-security",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "stage":
                      window.open(
                        "https://stage.www.ticca.com/data-security",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    case "prod":
                      window.open(
                        "https://www.ticca.com/data-security",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                    default:
                      window.open(
                        "https://dev.www.ticca.com/data-security",
                        "_blank",
                        "noopener,noreferrer"
                      );
                      break;
                  }
                }}
              >
                Data Security
              </li>
            </ul>
          </div>
          <div>
            <p className="footer-list-title">
              Company{" "}
              <samp onClick={() => setFooterTICCAExp(!footerTICCAExp)}>
                {" "}
                <img
                  className={`${footerTICCAExp ? "samp-rotade" : ""}`}
                  src="https://public.ticca.com/images/svg/FooterArrow.svg"
                  alt="arrow down"
                />
              </samp>
            </p>
            <ul
              className={footerTICCAExp ? "active" : ""}
              style={{ display: `${footerTICCAExp ? "block" : "none"}` }}
            >
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.ticcaProduct}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                What
              </li>
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.WorkFromAnywhere}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Where
              </li>
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.innovation}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                How
              </li>
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.aboutUs}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Who
              </li>
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.When}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                When
              </li>
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.WhyChooseUs}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Why
              </li>
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.InvestorCenter}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Investor
              </li>
                <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.insights}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Insights
              </li>
              <li
                onClick={() => {
                  window.open(
                    `${window.location.origin}${PageRoutes.ContactUs}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
              >
                Contact
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
